// src/config.js
const config = {
    //BASE_URL: "http://localhost:5000",  // Use the actual base URL of your API
    BASE_URL: "https://api.iveydb.com",  // Use the actual base URL of your API
    //BASE_URL: "http://92.205.129.171:5000",  // Use the actual base URL of your API
};
  
export default config;
  